import { captureMiddlewareError } from './captureMiddlewareError'
import { createApiResponseError } from '../default/ApiResponseError'
import { captureMiddlewarePerformance } from './captureMiddlewarePerformance'
import { getMiddlewareHeaders } from './getMiddlewareHeaders'
import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * Verifies a phone number
 * @returns {Promise<GetLocResponse>}
 */
export async function getLoc() {
  const apiBase = getMiddlewareUrl()
  const endpoint = '/api/ip-location'
  const url = `${apiBase}${endpoint}`
  const CAPTURE_ID = `getLoc@${url}`

  const startTime = performance.now()
  try {
    const response = await fetch(url, {
      headers: getMiddlewareHeaders(),
      method: 'GET',
    })

    captureMiddlewarePerformance(CAPTURE_ID, performance.now() - startTime)

    if (response.ok) {
      const data = await response.json()
      return data || {}
    }

    throw await createApiResponseError(response, endpoint)
  } catch (error) {
    captureMiddlewarePerformance(CAPTURE_ID, performance.now() - startTime)
    captureMiddlewareError(CAPTURE_ID, /** @type {Error} */ (error), false)
    return {}
  }
}
